import React, { useState } from 'react';
import { X } from 'lucide-react';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      url: 'https://images.unsplash.com/flagged/photo-1551854716-8b811be39e7e',
      alt: 'Bridal Makeup 1'
    },
    {
      url: 'https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6',
      alt: 'Bridal Makeup 2'
    },
    {
      url: 'https://images.unsplash.com/photo-1684868682581-4cac3af5b8d4',
      alt: 'Bridal Makeup 3'
    },
    {
      url: 'https://images.unsplash.com/photo-1684868265714-fd2300637c23',
      alt: 'Bridal Makeup 4'
    },
    {
      url: 'https://images.unsplash.com/photo-1594465919760-441fe5908ab0',
      alt: 'Beauty Makeup 1'
    },
    {
      url: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2',
      alt: 'Beauty Makeup 2'
    },
    {
      url: 'https://images.unsplash.com/photo-1653641621097-d25366c2c6a4',
      alt: 'Beauty Makeup 3'
    },
    {
      url: 'https://images.unsplash.com/photo-1653640869615-e9878a2c8344',
      alt: 'Beauty Makeup 4'
    },
    {
      url: 'https://images.pexels.com/photos/2332376/pexels-photo-2332376.jpeg',
      alt: 'Bridal Makeup 5'
    },
    {
      url: 'https://images.pexels.com/photos/2808556/pexels-photo-2808556.jpeg',
      alt: 'Wedding Makeup'
    },
    {
      url: 'https://images.pexels.com/photos/1446161/pexels-photo-1446161.jpeg',
      alt: 'Bridal Look'
    },
    {
      url: 'https://images.pexels.com/photos/2106685/pexels-photo-2106685.jpeg',
      alt: 'Wedding Style'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-white to-rose-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-rose-500 text-sm font-medium tracking-wider uppercase mb-2">Portfolio</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-4">Where Artistry Meets Beauty</h2>
          <p className="text-stone-600 max-w-2xl mx-auto">Explore our captivating beautician portfolio</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-7xl mx-auto">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-xl aspect-square"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white font-medium text-sm px-4 text-center">View Full Image</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-rose-400 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;